"use client";

import { currencyFormatter, percentage } from "@repo/next-shared/utils";
import { cn } from "@repo/ui/lib/utils";

type DifferencePriceProps = {
  offerPrice: number | string;
  sellingPrice: number | string;
  delta?: number;
  deltaPercentage?: number;
};

export default function DifferencePrice({
  offerPrice,
  sellingPrice,
  delta,
  deltaPercentage,
}: DifferencePriceProps) {
  const parsedOfferPrice = Number(offerPrice);
  const parsedSellingPrice = Number(sellingPrice);

  const priceDifference = delta ?? parsedOfferPrice - parsedSellingPrice;
  const percentageDifference =
    deltaPercentage != null
      ? `${deltaPercentage}%`
      : percentage(parsedSellingPrice, parsedOfferPrice);

  return (
    <div>
      <span
        className={cn(
          "font-bold",
          priceDifference > 0 ? "text-[#00A825]" : "text-[#C90000]",
        )}
      >
        {priceDifference > 0
          ? `+${currencyFormatter().format(priceDifference)}`
          : currencyFormatter().format(priceDifference)}{" "}
        ({percentageDifference})
      </span>
    </div>
  );
}
